import { Box, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Campaigns.Campaign.Page;

export const DonationUnavailableMessage = () => {
  const { t } = useResource();

  return (
    <Box
      sx={{
        width: "100%",
        p: 3,
        border: "1px dashed",
        borderColor: "divider",
        borderRadius: 2,
        textAlign: "center",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {t(RESOURCES.DonationsNotAvailable)}
      </Typography>
    </Box>
  );
};
